
import Vue from 'vue';
import Helpers from "@/utilities/Helpers";

// localStorage.setItem("permissoes", JSON.stringify(undefined)) grava a string literal
// "undefined" (nao null) - JSON.parse("undefined") lanca SyntaxError e quebra o import do
// modulo inteiro. Trata "undefined"/vazio junto com null pra nunca deixar isso derrubar o app.
function obterPermissoesArmazenadas() {
    const bruto = localStorage.getItem("permissoes");
    if (!bruto || bruto === "undefined") return "";
    try {
        return JSON.parse(bruto);
    } catch (e) {
        return "";
    }
}

const state = {
    usuario: {
        userToken: localStorage.getItem("userToken"),
        userId: localStorage.getItem("userId"),
        personId: localStorage.getItem("personId"),
        cpfCnpj: localStorage.getItem("cpfCnpj"),
        codCorretor: localStorage.getItem("codCor"),
        email: localStorage.getItem("email"),
        permissao: localStorage.getItem("permissao"),
        permissoes: obterPermissoesArmazenadas(),
        tipo: localStorage.getItem("tipo"),
        userRoleId: localStorage.getItem("userRoleId"),
        childRoleId: process.env.VUE_APP_CHILD_ROLE_ID,        
        nome: localStorage.getItem("nome"),
        emailAuxiliar: "",
        usuarioId: "",
        loginId: "",
        hash: localStorage.getItem("cota_mais_hash"),
        token: localStorage.getItem("cota_mais_token")
    }
}

const mutations = {
    saveState: (state, payload) => {
        state.pessoa = payload;
    },
}

const actions = {
    saveState: ({ commit }, payload) => {
        commit('saveState', payload);
    }
}

const getters = {
    getUsuario: state => {
        return state.usuario;
    },

    getUserInfo: state => {
        state.usuario.codCorretor = localStorage.getItem("codCor");
        state.usuario.nome = localStorage.getItem("nome");
        state.usuario.cpfCnpj = localStorage.getItem("cpfCnpj");
        state.usuario.email = localStorage.getItem("email");
        state.usuario.emailAuxiliar = localStorage.getItem("emailAuxiliar");
        state.usuario.tipo = localStorage.getItem("tipo");
        state.usuario.permissao = localStorage.getItem("permissao");
        state.usuario.loginId = localStorage.getItem("loginId");
        state.usuario.hash = localStorage.getItem("cota_mais_hash");
        state.usuario.token = localStorage.getItem("cota_mais_token");
        state.usuario.personId = localStorage.getItem("personId");

        return state.usuario;
    },

    getUserInfoTest: state => {
        let userRoleId = localStorage.getItem('userRoleId');
        if (state.usuario.codCorretor == null || state.usuario.codCorretor == 0 || state.usuario.permissoes == "" || state.usuario.email == null || state.usuario.email.indexOf('@') == -1)
        {
          console.log(state.usuario.codCorretor);
          Vue.prototype.$httpIdentityServerApi.get(`userRole/${userRoleId}`, {              
                headers: { "content-type": "application/json" }
            }).then(response => {
                console.log("getUserInfo");
                console.log(response.data);
                let userInfo = response.data;
                localStorage.setItem("userId", userInfo.userId);
                localStorage.setItem("personId", userInfo.personId);
                localStorage.setItem("codCor", userInfo.code);
                localStorage.setItem("email", userInfo.emailPerson);
                localStorage.setItem("nome", userInfo.namePerson);           
                localStorage.setItem("permissao", userInfo.nameRole);
                localStorage.setItem("tipo", userInfo.nameRole);           
                localStorage.setItem("permissoes", JSON.stringify(userInfo.roleClaims || []));

                state.usuario.userId = userInfo.userId;
                state.usuario.codCorretor = userInfo.code;
                state.usuario.personId = userInfo.personId;
                state.usuario.email = userInfo.emailPerson;
                state.usuario.nome = userInfo.namePerson;
                state.usuario.permissao = userInfo.nameRole;
                state.usuario.tipo = userInfo.nameRole;                
                state.usuario.permissoes = userInfo.roleClaims;
                
                return state.usuario;
            }).catch(ex => {
                console.log("catch(ex)");
                console.log(ex);
            });   
        }
        else
        {
            state.usuario.userId = localStorage.getItem("userId");
            state.usuario.nome = localStorage.getItem("nome");
            state.usuario.codCorretor = localStorage.getItem("codCor");
            state.usuario.personId = localStorage.getItem("personId");
            state.usuario.email = localStorage.getItem("email");
            state.usuario.permissao = localStorage.getItem("permissao");
            state.usuario.tipo = localStorage.getItem("tipo");                
            state.usuario.permissoes = obterPermissoesArmazenadas();
        } 
        
        return state.usuario;
    },

    getSessaoUsuario: state => {
        let hash = Helpers.methods.obterParametrosURL()["hash"];
        let token = Helpers.methods.obterParametrosURL()["token"];
        let codCorretor = localStorage.getItem("codCor");
        let hashCheck = localStorage.getItem("cota_mais_hash");
        let tokenCheck = localStorage.getItem("cota_mais_token");

        if (hash === "" || hash === null || hash === undefined) hash = hashCheck;
        if (token === "" || token === null || token === undefined) token = tokenCheck;

        if (codCorretor !== null && codCorretor !== "undefined" && codCorretor !== undefined && hashCheck === hash && tokenCheck === token) {
            state.usuario.codCorretor = codCorretor;
            state.usuario.nome = localStorage.getItem("nome");
            state.usuario.email = localStorage.getItem("email");
            state.usuario.emailAuxiliar = localStorage.getItem("emailAuxiliar");
            state.usuario.tipo = localStorage.getItem("tipo");
            state.usuario.permissao = localStorage.getItem("permissao");
            state.usuario.loginId = localStorage.getItem("loginId");
            state.usuario.hash = localStorage.getItem("cota_mais_hash");
            state.usuario.token = localStorage.getItem("cota_mais_token");
        }
        
        return state.usuario;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


